<template>
  <v-card flat class="pa-10 justify-center" width="600px">
    <p class="text-center font-weight-bold">{{ $t('shootings.title') }}</p>
    <v-form ref="form" @submit.prevent="search">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="registration"
            :placeholder="$t('shootings.researchRegistration')"
            class="center-text"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <Datepicker :label="$t('shootings.startDate')" path="startDate" />
        </v-col>
        <v-col cols="12" md="4">
          <Datepicker :label="$t('shootings.endDate')" path="endDate" />
        </v-col>
      </v-row>
      <ShootingsFilterType class="mb-2" />
      <div class="center-block-btn">
        <ButtonDefault
          class="mx-2"
          :minWidth="'30%'"
          :outlined="true"
          :buttonName="$t('shootings.resetButton')"
          @click="clear"
        />
        <ButtonDefault
          class="mx-2"
          :minWidth="'30%'"
          :buttonName="$t('shootings.researchButton')"
          :disabled="!ruleTypes"
          @click="search"
        />
      </div>
    </v-form>
  </v-card>
</template>

<script>
import Datepicker from '@/components/Datepicker.vue'
import ShootingsFilterType from '@/components/shootings/ShootingsFilterType'
import ButtonDefault from '@/components/common/atoms/ButtonDefault.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ResearchShooting',
  components: {
    Datepicker,
    ShootingsFilterType,
    ButtonDefault
  },
  computed: {
    ...mapGetters(['userId']),
    ...mapState({
      startDate: state => state.researchShooting.current.startDate,
      endDate: state => state.researchShooting.current.endDate,
      types: state => state.researchShooting.current.types
    }),
    ruleTypes() {
      return this.types.length > 0
    },
    registration: {
      get: function() {
        return this.$store.state.researchShooting.current.registration
      },
      set: function(registration) {
        this.$store.commit('RESEARCH_REGISTRATION', registration)
      }
    }
  },
  methods: {
    clear() {
      this.$mam.shootingsSearchReset()
      this.$store.commit('RESET_RESEARCH')
      this.search()
    },
    search() {
      const body = {
        userId: this.userId,
        startDate: this.startDate,
        endDate: this.endDate,
        registration: this.registration,
        types: this.types
      }

      this.$store.dispatch('researchShooting', body)
      this.$mam.shootingsSearch()
    }
  }
}
</script>

<style lang="less" scoped>
.center-block-btn {
  display: flex;
  justify-content: center;
}
</style>

<style lang="less">
.center-text {
  text-align-last: center;
}
</style>
